// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

//added components
import { Container, Grid, List, ListItem, ListItemText } from "@mui/material";

//images
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

// Authentication layout components
import PageLayout from "examples/LayoutContainers/PageLayout";
import Header from "layouts/home/components/header";
import Footer from "layouts/home/components/footer";
import { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Helmet } from "react-helmet-async";

function PrivacyPolicy() {
  const [showButton, setShowButton] = useState(false);
  const [bottomOffset, setBottomOffset] = useState(20);
  console.log(bottomOffset, "bottom ");
  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const mobileBottomOffset = 395;
      const desktopBottomOffset = 320;

      setShowButton(scrollY > 500);

      if (windowHeight + scrollY >= documentHeight - 100) {
        setBottomOffset(isMobile ? mobileBottomOffset : desktopBottomOffset);
      } else {
        setBottomOffset(20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const itemFour = [
    "<strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.",
    `<strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.`,
    `<strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Tavlo AI, Washignton DC, 20001.`,
    "<strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses",
    "<strong>Country</strong> refers to: Washington, United States",
    "<strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.",
    "<strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.",
    "<strong>Service</strong> refers to the Website.",
    "<strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.",
    "<strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).",
    "<strong>Website</strong> refers to TavloAI, accessible from https://tavloai.com/",
    "<strong>You </strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.",
  ];
  const itemTwo = [
    "Email address",
    "First name and last name",
    "Phone number",
    "Usage Data",
  ];
  const itemtre = [
    "<strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.",
    "<strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).",
  ];
  const itemFive = [
    "To provide and maintain our Service, including to monitor the usage of our Service.",
    "<strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.",
    "<strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.",
    "<strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.",
    "To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.",
    "<strong>To manage Your requests:</strong> To attend and manage Your requests to Us.",
    "<strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.",
    "<strong>For other purposes:</strong> We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.",
  ];
  const itemSixx = [
    "   <strong>  With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.",
    "<strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.",
    "<strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.",
    "<strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.",
    "<strong>With other users: </strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.",
    "<strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.",
  ];
  const itemSeve = [
    "Comply with a legal obligation",
    "Protect and defend the rights or property of the Company",
    "Prevent or investigate possible wrongdoing in connection with the Service",
    "Protect the personal safety of Users of the Service or the public",
    "Protect against legal liability",
  ];
  const data = [
    {
      heading: "Necessary / Essential Cookies",
      content: `Type: Session Cookies\n\nAdministered by: Us\n\nPurpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.`,
    },
    {
      heading: "Cookies Policy / Notice Acceptance Cookies",
      content: `Type: Persistent Cookies\n\nAdministered by: Google\n\nPurpose: These Cookies identify if users have accepted the use of cookies on the Website.`,
    },
    {
      heading: "Functionality Cookies",
      content: `Type: Persistent Cookies\n\nAdministered by: Google\n\nPurpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.`,
    },
  ];
  const itemEight = ["By email: support@tavloai.com"];
  return (
    <>
      <Header />
      <Helmet>
        <title> TavloAI Privacy Policy | Your Data Our Commitment</title>
        <meta
          name="description"
          content=" Read TavloAI’s Privacy Policy to learn how we collect, use, and protect your information while providing AI-driven solutions for your business."
        />
        <meta name="keywords" content="Privacy Policy" />
      </Helmet>
      <PageLayout>
        <Container
          sx={{
            minHeight: "100vh",
            textAlign: "start",
            maxWidth: "700px",
            margin: "0 auto",
            marginTop: {
              xs: "70px",
              sm: "70px",
              md: "100px",
            },
            marginBottom: "30px",
          }}
        >
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "28px",
                  sm: "38px",
                  md: "48px",
                },
                color: "#000",
              }}
              // style={{ fontSize: "48px", color: "#000" }}
            >
              Privacy Policy
            </MDTypography>
          </MDBox>

          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Last updated: August 12, 2025
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </MDBox>

          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We use Your Personal data to provide and improve the Service. By
            using the Service, You agree to the collection and use of
            information in accordance with this Privacy Policy. This Privacy
            Policy has been created with the help of the Privacy Policy
            Generator.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "20px",
                  sm: "28px",
                  md: "38px",
                },
                color: "#000",
              }}
            >
              Interpretation and Definitions
            </MDTypography>
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Interpretation
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Definitions
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            For the purposes of this Privacy Policy:
          </MDBox>

          <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
            {itemFour.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: { xs: "5px", sm: "10px", md: "10px" },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={
                    <MDTypography
                      variant="h1"
                      fontWeight="medium"
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: { xs: "10px", sm: "14px", md: "16px" },
                        color: "#000",
                        lineHeight: {
                          xs: "15px",
                          sm: "24px",
                          md: 1.6,
                        },
                        mb: {
                          xs: 1,
                          sm: 0,
                          md: 1.5,
                        },
                        textAlign: "justify",
                      }}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  }
                />
              </ListItem>
            ))}
          </List>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "20px",
                  sm: "28px",
                  md: "38px",
                },
                color: "#000",
              }}
            >
              Collecting and Using Your Personal Data
            </MDTypography>
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Types of Data Collected
            </MDTypography>
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              <MDBox sx={{ textAlign: "start" }}>
                <MDTypography
                  variant="h1"
                  fontWeight="medium"
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "28px",
                      md: "28px",
                    },
                    color: "#000",
                  }}
                >
                  Personal Data
                </MDTypography>
              </MDBox>
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            While using Our Service, We may ask You to provide Us with certain
            personally identifiable information that can be used to contact or
            identify You. Personally identifiable information may include, but
            is not limited to:
          </MDBox>

          <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
            {itemTwo.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: {
                      xs: "5px",
                      sm: "10px",
                      md: "15px",
                    },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "urbanist",
                      fontWeight: 400,
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      color: "#000",
                      fontFamily: "Poppins",
                      lineHeight: {
                        xs: 2.1,
                        sm: 2.2,
                        md: 2.2,
                      },
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Usage Data
            </MDTypography>
          </MDBox>

          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Usage Data is collected automatically when using the Service.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Usage Data may include information such as Your Device's Internet
            Protocol address (e.g. IP address), browser type, browser version,
            the pages of our Service that You visit, the time and date of Your
            visit, the time spent on those pages, unique device identifiers and
            other diagnostic data.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            When You access the Service by or through a mobile device, We may
            collect certain information automatically, including, but not
            limited to, the type of mobile device You use, Your mobile device
            unique ID, the IP address of Your mobile device, Your mobile
            operating system, the type of mobile Internet browser You use,
            unique device identifiers and other diagnostic data.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We may also collect information that Your browser sends whenever You
            visit our Service or when You access the Service by or through a
            mobile device.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Tracking Technologies and Cookies
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We use Cookies and similar tracking technologies to track the
            activity on Our Service and store certain information. Tracking
            technologies used are beacons, tags, and scripts to collect and
            track information and to improve and analyze Our Service. The
            technologies We use may include:
          </MDBox>
          <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
            {itemtre.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: { xs: "5px", sm: "10px", md: "10px" },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={
                    <MDTypography
                      variant="h1"
                      fontWeight="medium"
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: { xs: "10px", sm: "14px", md: "16px" },
                        color: "#000",
                        lineHeight: {
                          xs: "15px",
                          sm: "24px",
                          md: 1.6,
                        },
                        mb: {
                          xs: 1,
                          sm: 0,
                          md: 1.5,
                        },
                        textAlign: "justify",
                      }}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  }
                />
              </ListItem>
            ))}
          </List>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
            remain on Your personal computer or mobile device when You go
            offline, while Session Cookies are deleted as soon as You close Your
            web browser. You can learn more about cookies on TermsFeed website
            article.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We use both Session and Persistent Cookies for the purposes set out
            below:
          </MDBox>

          {/* djfgjdjkdfjgkldjfgkdjgklfjdklgjdklgjldkfg */}
          <List>
            {data.map((item, index) => (
              <ListItem key={index} alignItems="flex-start" sx={{ mb: 2 }}>
                <MDBox sx={{ mr: 1, mt: 1.5, fontSize: "6px" }}>
                  <FiberManualRecordIcon sx={{ color: "#000", fontSize: 6 }} />
                </MDBox>

                <ListItemText
                  primary={item.heading}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "Poppins",
                      fontWeight: 600,
                      fontSize: { xs: "12px", sm: "14px", md: "18px" },
                      color: "#000",
                    },
                  }}
                  secondary={item.content}
                  secondaryTypographyProps={{
                    sx: {
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: { xs: "10px", sm: "13px", md: "16px" },
                      color: "#000",
                      whiteSpace: "pre-line",
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>

          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            For more information about the cookies we use and your choices
            regarding cookies, please visit our Cookies Policy or the Cookies
            section of our Privacy Policy.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Use of Your Personal Data
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Company may use Personal Data for the following purposes:
          </MDBox>
          <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
            {itemFive.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: { xs: "5px", sm: "10px", md: "10px" },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={
                    <MDTypography
                      variant="h1"
                      fontWeight="medium"
                      sx={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: { xs: "10px", sm: "14px", md: "16px" },
                        color: "#000",
                        lineHeight: {
                          xs: "15px",
                          sm: "24px",
                          md: 1.6,
                        },
                        mb: {
                          xs: 1,
                          sm: 0,
                          md: 1.5,
                        },
                        textAlign: "justify",
                      }}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  }
                />
              </ListItem>
            ))}
          </List>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We may share Your personal information in the following situations:
          </MDBox>

          {itemSixx.map((item, index) => (
            <ListItem key={index} disableGutters alignItems="flex-start">
              <MDBox
                sx={{
                  marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                  fontSize: "6px",
                  mr: 1,
                  lineHeight: 2.2,
                  mt: { xs: "15px", sm: "10px", md: "15px" },
                }}
              >
                <FiberManualRecordIcon sx={{ color: "#000" }} />
              </MDBox>
              <ListItemText
                primary={
                  <MDTypography
                    variant="h1"
                    fontWeight="medium"
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: { xs: "10px", sm: "14px", md: "16px" },
                      color: "#000",
                      lineHeight: {
                        xs: "15px",
                        sm: "24px",
                        md: 1.6,
                      },
                      mb: {
                        xs: 1,
                        sm: 0,
                        md: 1.5,
                      },
                      textAlign: "justify",
                    }}
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                }
              />
            </ListItem>
          ))}

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Retention of Your Personal Data
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Company will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations (for example, if we are required to
            retain your data to comply with applicable laws), resolve disputes,
            and enforce our legal agreements and policies.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Company will also retain Usage Data for internal analysis
            purposes. Usage Data is generally retained for a shorter period of
            time, except when this data is used to strengthen the security or to
            improve the functionality of Our Service, or We are legally
            obligated to retain this data for longer time periods.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Transfer of Your Personal Data
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Your information, including Personal Data, is processed at the
            Company's operating offices and in any other places where the
            parties involved in the processing are located. It means that this
            information may be transferred to — and maintained on — computers
            located outside of Your state, province, country or other
            governmental jurisdiction where the data protection laws may differ
            than those from Your jurisdiction.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Your consent to this Privacy Policy followed by Your submission of
            such information represents Your agreement to that transfer.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Company will take all steps reasonably necessary to ensure that
            Your data is treated securely and in accordance with this Privacy
            Policy and no transfer of Your Personal Data will take place to an
            organization or a country unless there are adequate controls in
            place including the security of Your data and other personal
            information.
          </MDBox>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Delete Your Personal Data
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You have the right to delete or request that We assist in deleting
            the Personal Data that We have collected about You.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Our Service may give You the ability to delete certain information
            about You from within the Service.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You may update, amend, or delete Your information at any time by
            signing in to Your Account, if you have one, and visiting the
            account settings section that allows you to manage Your personal
            information. You may also contact Us to request access to, correct,
            or delete any personal information that You have provided to Us.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Please note, however, that We may need to retain certain information
            when we have a legal obligation or lawful basis to do so.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Disclosure of Your Personal Data
            </MDTypography>
          </MDBox>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Business Transactions
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            If the Company is involved in a merger, acquisition or asset sale,
            Your Personal Data may be transferred. We will provide notice before
            Your Personal Data is transferred and becomes subject to a different
            Privacy Policy.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Law enforcement
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Under certain circumstances, the Company may be required to disclose
            Your Personal Data if required to do so by law or in response to
            valid requests by public authorities (e.g. a court or a government
            agency).
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Other legal requirements
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            The Company may disclose Your Personal Data in the good faith belief
            that such action is necessary to:
          </MDBox>
          <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
            {itemSeve.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: {
                      xs: "5px",
                      sm: "10px",
                      md: "15px",
                    },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "urbanist",
                      fontWeight: 400,
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      color: "#000",
                      fontFamily: "Poppins",
                      lineHeight: {
                        xs: 2.1,
                        sm: 2.2,
                        md: 2.2,
                      },
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>

          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Children's Privacy
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 13. If You are a parent or guardian and You are
            aware that Your child has provided Us with Personal Data, please
            contact Us. If We become aware that We have collected Personal Data
            from anyone under the age of 13 without verification of parental
            consent, We take steps to remove that information from Our servers.
          </MDBox>

          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            If We need to rely on consent as a legal basis for processing Your
            information and Your country requires consent from a parent, We may
            require Your parent's consent before We collect and use that
            information.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Links to Other Websites
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Our Service may contain links to other websites that are not
            operated by Us. If You click on a third party link, You will be
            directed to that third party's site. We strongly advise You to
            review the Privacy Policy of every site You visit.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third party sites or
            services.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Changes to this Privacy Policy
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We may update Our Privacy Policy from time to time. We will notify
            You of any changes by posting the new Privacy Policy on this page.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            We will let You know via email and/or a prominent notice on Our
            Service, prior to the change becoming effective and update the "Last
            updated" date at the top of this Privacy Policy.
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </MDBox>
          <MDBox sx={{ textAlign: "start" }}>
            <MDTypography
              variant="h1"
              fontWeight="medium"
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "28px",
                  md: "28px",
                },
                color: "#000",
              }}
            >
              Contact Us
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            If you have any questions about this Privacy Policy, You can contact
            us:
          </MDBox>

          <List sx={{ mb: { xs: 0, sm: 1, md: 3 } }}>
            {itemEight.map((item, index) => (
              <ListItem key={index} disableGutters alignItems="flex-start">
                <MDBox
                  sx={{
                    marginLeft: { xs: "0px", sm: "15px", md: "15px" },
                    fontSize: "6px",
                    mr: 1,
                    lineHeight: 2.2,
                    mt: {
                      xs: "5px",
                      sm: "10px",
                      md: "15px",
                    },
                  }}
                >
                  <FiberManualRecordIcon sx={{ color: "#000" }} />
                </MDBox>
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "urbanist",
                      fontWeight: 400,
                      fontSize: {
                        xs: "10px",
                        sm: "14px",
                        md: "16px",
                      },
                      color: "#000",
                      fontFamily: "Poppins",
                      lineHeight: {
                        xs: 2.1,
                        sm: 2.2,
                        md: 2.2,
                      },
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>

          <MDBox
            sx={{
              fontSize: {
                xs: "10px",
                sm: "16px",
                md: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "15px",
                sm: "24px",
                md: "30px",
              },
              color: "#000",
              marginBottom: "15px",
              fontFamily: "Poppins",
              textAlign: "justify",
            }}
          >
            Generated using TermsFeed Privacy Policy Generator
          </MDBox>
          {showButton && (
            <MDBox
              sx={{
                position: "fixed",
                bottom: bottomOffset,
                right: { xs: 20, md: 35 },
                zIndex: 9999,
              }}
            >
              <MDBox
                onClick={scrollToTop}
                sx={{
                  cursor: "pointer",
                  p: { xs: 0.5, md: 1 },
                  backgroundColor: "#F47C00",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "30px",
                }}
              >
                <ArrowUpwardIcon sx={{ color: "#fff", fontSize: "30px" }} />
              </MDBox>
            </MDBox>
          )}
        </Container>
        <Footer />
      </PageLayout>
    </>
  );
}

export default PrivacyPolicy;
